export default "__VITE_PUBLIC_ASSET__5928da1c__"